module.exports = __webpack_public_path__ + "static/media/6-mobile.703e9c6b.jpg";